import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DeploymentStage } from '../../models/devops-mock.data';

@Component({
  selector: 'app-deployment-stage-card',
  imports: [TranslatePipe],
  templateUrl: './deployment-stage-card.component.html',
  styleUrl: './deployment-stage-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeploymentStageCardComponent {
  readonly stage = input.required<DeploymentStage>();
}
